/** @format */

import {CampaignKind} from 'types';

import {
  AutoTargetingData,
  GenderAgeData,
  NotFoundPagesData,
  RecommendationData,
  RecommendationType,
  RegionData,
  RSAPlatformData,
} from './interfaces';
import {RecommendationsItemType} from './types';

const mapApiDataToNotFoundPages = (
  recommendationItemsData: RecommendationsItemType[],
): NotFoundPagesData[] => {
  return recommendationItemsData.map(item => ({
    subAccount: item.account,
    campaignId: item.campaignId,
    campaignName: item.campaign,
    linkType: item.objects?.linkType?.value || '',
    link: item.objects?.finalUrl?.value || item.objects?.link?.value || '',
  }));
};

const mapApiDataToAutoTargeting = (
  recommendationItemsData: RecommendationsItemType[],
): AutoTargetingData[] => {
  return recommendationItemsData.map(item => ({
    subAccount: item.account,
    showType: item.objects?.campaignKind?.value as CampaignKind,
    campaignId: item.campaignId,
    campaignName: item.campaign,
    groupId: item.adGroupId || '',
    groupName: item.adGroup || '',
    autoTargetingRate: item.objects?.autotargetingBidSearch?.value || '',
  }));
};

const mapApiDataToRSAPlatform = (
  recommendationItemsData: RecommendationsItemType[],
): RSAPlatformData[] => {
  return recommendationItemsData.map(item => ({
    subAccount: item.account,
    showType: item.objects?.campaignKind?.value as CampaignKind,
    platform: item.objects?.placement?.value || '',
    plannedKPI: item.objects?.metricLimit?.value || '',
    actualKPI: item.objects?.metricValue?.value || '',
  }));
};

const mapApiDataToGenderAge = (
  recommendationItemsData: RecommendationsItemType[],
): GenderAgeData[] => {
  return recommendationItemsData.map(item => ({
    subAccount: item.account,
    showType: item.objects?.campaignKind?.value as CampaignKind,
    gender: item.objects?.gender?.value || '',
    age: item.objects?.age?.value || '',
    plannedKPI: item.objects?.metricLimit?.value || '',
    actualKPI: item.objects?.metricValue?.value || '',
    correction: item.objects?.correction?.value || '',
  }));
};

const mapApiDataToRegion = (recommendationItemsData: RecommendationsItemType[]): RegionData[] => {
  return recommendationItemsData.map(item => ({
    subAccount: item.account,
    showType: item.objects?.campaignKind?.value as CampaignKind,
    region: item.objects?.targetLoc?.value || '',
    plannedKPI: item.objects?.metricLimit?.value || '',
    actualKPI: item.objects?.metricValue?.value || '',
    correction: item.objects?.correction?.value || '',
  }));
};

export const getDataForDisplay = (
  type: RecommendationType,
  recommendationItemsData?: RecommendationsItemType[],
): RecommendationData[] => {
  if (!recommendationItemsData) {
    return [];
  }

  if (type === RecommendationType.NOT_FOUND_PAGES) {
    return mapApiDataToNotFoundPages(recommendationItemsData);
  }

  if (type === RecommendationType.AUTO_TARGETING) {
    return mapApiDataToAutoTargeting(recommendationItemsData);
  }

  if (type === RecommendationType.RSA_PLATFORM) {
    return mapApiDataToRSAPlatform(recommendationItemsData);
  }

  if (type === RecommendationType.GENDER_AGE) {
    return mapApiDataToGenderAge(recommendationItemsData);
  }

  if (type === RecommendationType.REGION) {
    return mapApiDataToRegion(recommendationItemsData);
  }

  return [];
};
